import React from "react";
import styles from "./Sidebar.module.scss";
import { Link, NavLink, useLocation } from "react-router-dom";

// img
import logo from "../../../Assets/images/logo.png";
import { Accordion, Button } from "react-bootstrap";

const Sidebar = ({ sidebar, setSidebar }) => {
  const location = useLocation();
  const pageActive = location.pathname;
  const handleSidebar = () => {
    setSidebar(!sidebar);
  };
  return (
    <div
      className={`${styles.sidebar} ${sidebar && styles.active
        } pt-4 position-fixed`}
    >
      <Button
        onClick={handleSidebar}
        variant="transparent"
        className="position-absolute border-0 p-2 closeBtn d-lg-none"
        style={{ top: 0, right: 0 }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="21"
          viewBox="0 0 15 21"
          fill="none"
        >
          <path
            d="M7.245 6.529L10.668 1.3H14.259V1.447L9.303 8.608L14.343 15.895V16H10.71L7.245 10.834L3.78 16H0.147V15.895L5.145 8.608L0.21 1.447V1.3H3.801L7.245 6.529Z"
            fill="white"
          />
        </svg>
      </Button>
      <div className={`${styles.top} top text-center px-3 py-2`}>
        <Link to="/" className={`${styles.logo} logo`}>
          <img src={logo} alt="" className="img-fluid" />
        </Link>
      </div>
      <Accordion className={`${styles.linkWrpper} linkWrpper py-4`}>
        <ul className="list-unstyled ps-0 mb-0 ">
          <li className="">
            <NavLink
              to="/dashboard"
              className={`${styles.link} ${pageActive.includes("/dashboard") && styles.active
                } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <path
                    d="M2.5 0H9.14551C10.5273 0 11.6455 1.11816 11.6455 2.5V5.93262C11.6455 7.31445 10.5273 8.43262 9.14551 8.43262H2.5C1.11816 8.43262 0 7.31445 0 5.93262V2.5C0 1.11816 1.11816 0 2.5 0Z"
                    fill="white"
                  />
                  <path
                    d="M2.5 10.2295H9.14551C10.5273 10.2295 11.6455 11.3477 11.6455 12.7295V22.5C11.6455 23.8818 10.5273 25 9.14551 25H2.5C1.11816 25 0 23.8818 0 22.5V12.7295C0 11.3477 1.11816 10.2295 2.5 10.2295Z"
                    fill="white"
                  />
                  <path
                    d="M15.8545 16.5674H22.5C23.8818 16.5674 25 17.6855 25 19.0674V22.5C25 23.8818 23.8818 25 22.5 25H15.8545C14.4727 25 13.3545 23.8818 13.3545 22.5V19.0674C13.3545 17.6855 14.4727 16.5674 15.8545 16.5674Z"
                    fill="white"
                  />
                  <path
                    d="M15.8545 0H22.5C23.8818 0 25 1.11816 25 2.5V12.2705C25 13.6523 23.8818 14.7705 22.5 14.7705H15.8545C14.4727 14.7705 13.3545 13.6523 13.3545 12.2705V2.5C13.3545 1.11816 14.4727 0 15.8545 0Z"
                    fill="white"
                  />
                </svg>
              </span>
              Dashboard
            </NavLink>
          </li>
          <li className="">
            <NavLink
              to="/manage-customers"
              className={`${styles.link} ${pageActive.includes("/manage-customers") && styles.active
                } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 25 22"
                  fill="none"
                >
                  <path
                    d="M12.5 8.49609C14.8461 8.49609 16.748 6.59418 16.748 4.24805C16.748 1.90192 14.8461 0 12.5 0C10.1539 0 8.25195 1.90192 8.25195 4.24805C8.25195 6.59418 10.1539 8.49609 12.5 8.49609Z"
                    fill="white"
                  />
                  <path
                    d="M21.0938 8.49609C22.5769 8.49609 23.7793 7.29373 23.7793 5.81055C23.7793 4.32736 22.5769 3.125 21.0938 3.125C19.6106 3.125 18.4082 4.32736 18.4082 5.81055C18.4082 7.29373 19.6106 8.49609 21.0938 8.49609Z"
                    fill="white"
                  />
                  <path
                    d="M3.90625 8.49609C5.38944 8.49609 6.5918 7.29373 6.5918 5.81055C6.5918 4.32736 5.38944 3.125 3.90625 3.125C2.42306 3.125 1.2207 4.32736 1.2207 5.81055C1.2207 7.29373 2.42306 8.49609 3.90625 8.49609Z"
                    fill="white"
                  />
                  <path
                    d="M6.55225 10.9079C5.49512 10.0417 4.53774 10.1564 3.31543 10.1564C1.4873 10.1564 0 11.6349 0 13.4518V18.7843C0 19.5734 0.644043 20.215 1.43604 20.215C4.85527 20.215 4.44336 20.2768 4.44336 20.0675C4.44336 16.2889 3.9958 13.5179 6.55225 10.9079Z"
                    fill="white"
                  />
                  <path
                    d="M13.6624 10.1758C11.5274 9.9977 9.6717 10.1778 8.07107 11.499C5.3925 13.6445 5.90798 16.5333 5.90798 20.0674C5.90798 21.0024 6.66872 21.7773 7.61794 21.7773C17.9247 21.7773 18.3349 22.1098 18.9461 20.7563C19.1465 20.2986 19.0916 20.4441 19.0916 16.0654C19.0916 12.5876 16.0802 10.1758 13.6624 10.1758Z"
                    fill="white"
                  />
                  <path
                    d="M21.6851 10.1563C20.4561 10.1563 19.504 10.0428 18.4482 10.9077C20.9856 13.4984 20.5571 16.0803 20.5571 20.0674C20.5571 20.278 20.2152 20.2149 23.5132 20.2149C24.3335 20.2149 25.0005 19.5503 25.0005 18.7334V13.4517C25.0005 11.6348 23.5132 10.1563 21.6851 10.1563Z"
                    fill="white"
                  />
                </svg>
              </span>
              Manage Customers
            </NavLink>
          </li>
             <li className="">
            <NavLink
              to="/notify-requests"
              className={`${styles.link} ${pageActive.includes("/notify-requests") && styles.active
                } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 25 22"
                  fill="none"
                >
                  <path
                    d="M12.5 8.49609C14.8461 8.49609 16.748 6.59418 16.748 4.24805C16.748 1.90192 14.8461 0 12.5 0C10.1539 0 8.25195 1.90192 8.25195 4.24805C8.25195 6.59418 10.1539 8.49609 12.5 8.49609Z"
                    fill="white"
                  />
                  <path
                    d="M21.0938 8.49609C22.5769 8.49609 23.7793 7.29373 23.7793 5.81055C23.7793 4.32736 22.5769 3.125 21.0938 3.125C19.6106 3.125 18.4082 4.32736 18.4082 5.81055C18.4082 7.29373 19.6106 8.49609 21.0938 8.49609Z"
                    fill="white"
                  />
                  <path
                    d="M3.90625 8.49609C5.38944 8.49609 6.5918 7.29373 6.5918 5.81055C6.5918 4.32736 5.38944 3.125 3.90625 3.125C2.42306 3.125 1.2207 4.32736 1.2207 5.81055C1.2207 7.29373 2.42306 8.49609 3.90625 8.49609Z"
                    fill="white"
                  />
                  <path
                    d="M6.55225 10.9079C5.49512 10.0417 4.53774 10.1564 3.31543 10.1564C1.4873 10.1564 0 11.6349 0 13.4518V18.7843C0 19.5734 0.644043 20.215 1.43604 20.215C4.85527 20.215 4.44336 20.2768 4.44336 20.0675C4.44336 16.2889 3.9958 13.5179 6.55225 10.9079Z"
                    fill="white"
                  />
                  <path
                    d="M13.6624 10.1758C11.5274 9.9977 9.6717 10.1778 8.07107 11.499C5.3925 13.6445 5.90798 16.5333 5.90798 20.0674C5.90798 21.0024 6.66872 21.7773 7.61794 21.7773C17.9247 21.7773 18.3349 22.1098 18.9461 20.7563C19.1465 20.2986 19.0916 20.4441 19.0916 16.0654C19.0916 12.5876 16.0802 10.1758 13.6624 10.1758Z"
                    fill="white"
                  />
                  <path
                    d="M21.6851 10.1563C20.4561 10.1563 19.504 10.0428 18.4482 10.9077C20.9856 13.4984 20.5571 16.0803 20.5571 20.0674C20.5571 20.278 20.2152 20.2149 23.5132 20.2149C24.3335 20.2149 25.0005 19.5503 25.0005 18.7334V13.4517C25.0005 11.6348 23.5132 10.1563 21.6851 10.1563Z"
                    fill="white"
                  />
                </svg>
              </span>
              Notify Requests
            </NavLink>
          </li>
          <li className="">
            <NavLink
              to="/manage-tiers"
              className={`${styles.link} ${pageActive.includes("/manage-tiers") && styles.active
                } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 25 22"
                  fill="none"
                >
                  <path
                    d="M12.5 8.49609C14.8461 8.49609 16.748 6.59418 16.748 4.24805C16.748 1.90192 14.8461 0 12.5 0C10.1539 0 8.25195 1.90192 8.25195 4.24805C8.25195 6.59418 10.1539 8.49609 12.5 8.49609Z"
                    fill="white"
                  />
                  <path
                    d="M21.0938 8.49609C22.5769 8.49609 23.7793 7.29373 23.7793 5.81055C23.7793 4.32736 22.5769 3.125 21.0938 3.125C19.6106 3.125 18.4082 4.32736 18.4082 5.81055C18.4082 7.29373 19.6106 8.49609 21.0938 8.49609Z"
                    fill="white"
                  />
                  <path
                    d="M3.90625 8.49609C5.38944 8.49609 6.5918 7.29373 6.5918 5.81055C6.5918 4.32736 5.38944 3.125 3.90625 3.125C2.42306 3.125 1.2207 4.32736 1.2207 5.81055C1.2207 7.29373 2.42306 8.49609 3.90625 8.49609Z"
                    fill="white"
                  />
                  <path
                    d="M6.55225 10.9079C5.49512 10.0417 4.53774 10.1564 3.31543 10.1564C1.4873 10.1564 0 11.6349 0 13.4518V18.7843C0 19.5734 0.644043 20.215 1.43604 20.215C4.85527 20.215 4.44336 20.2768 4.44336 20.0675C4.44336 16.2889 3.9958 13.5179 6.55225 10.9079Z"
                    fill="white"
                  />
                  <path
                    d="M13.6624 10.1758C11.5274 9.9977 9.6717 10.1778 8.07107 11.499C5.3925 13.6445 5.90798 16.5333 5.90798 20.0674C5.90798 21.0024 6.66872 21.7773 7.61794 21.7773C17.9247 21.7773 18.3349 22.1098 18.9461 20.7563C19.1465 20.2986 19.0916 20.4441 19.0916 16.0654C19.0916 12.5876 16.0802 10.1758 13.6624 10.1758Z"
                    fill="white"
                  />
                  <path
                    d="M21.6851 10.1563C20.4561 10.1563 19.504 10.0428 18.4482 10.9077C20.9856 13.4984 20.5571 16.0803 20.5571 20.0674C20.5571 20.278 20.2152 20.2149 23.5132 20.2149C24.3335 20.2149 25.0005 19.5503 25.0005 18.7334V13.4517C25.0005 11.6348 23.5132 10.1563 21.6851 10.1563Z"
                    fill="white"
                  />
                </svg>
              </span>
              Manage Tiers
            </NavLink>
          </li>
          <li className="">
            <Accordion.Item
              className={`${styles.accordionWrp} border-0 bg-transparent`}
              eventKey="0"
            >
              <Accordion.Header
                className={`${styles.accordionBtn} rotateIcon fw-bold d-flex align-items-center gap-10`}
              >
                <span className={`${styles.icn} ${styles.fill} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 25 25"
                    fill="none"
                  >
                    <path
                      d="M23.7492 18.7422H20.2245L21.0619 13.7426H22.4993C22.7613 13.7433 23.017 13.6616 23.23 13.509C23.4431 13.3565 23.6029 13.1409 23.6867 12.8926L24.9366 9.1429C25.0231 8.88169 25.021 8.59923 24.9306 8.33934C24.8402 8.07945 24.6666 7.85665 24.4367 7.7055L13.1875 0.20603C12.9834 0.0716298 12.7444 0 12.5 0C12.2556 0 12.0166 0.0716298 11.8125 0.20603L0.563337 7.7055C0.333403 7.85665 0.159771 8.07945 0.0693742 8.33934C-0.0210228 8.59923 -0.0231328 8.88169 0.0633716 9.1429L1.31328 12.8926C1.39713 13.1409 1.55689 13.3565 1.76997 13.509C1.98304 13.6616 2.23866 13.7433 2.5007 13.7426H3.9381L4.77554 18.7422H1.25079C0.919291 18.7422 0.601371 18.8739 0.366967 19.1083C0.132563 19.3427 0.000876005 19.6606 0.000876005 19.9921V23.7419C0.000876005 24.0734 0.132563 24.3913 0.366967 24.6257C0.601371 24.8601 0.919291 24.9918 1.25079 24.9918H23.7492C24.0807 24.9918 24.3986 24.8601 24.633 24.6257C24.8674 24.3913 24.9991 24.0734 24.9991 23.7419V19.9921C24.9991 19.6606 24.8674 19.3427 24.633 19.1083C24.3986 18.8739 24.0807 18.7422 23.7492 18.7422ZM17.6871 18.7422H13.7499V13.7426H18.5246L17.6871 18.7422ZM12.5 4.99319C12.9944 4.99319 13.4777 5.13981 13.8888 5.41449C14.2999 5.68918 14.6203 6.07959 14.8095 6.53638C14.9987 6.99316 15.0482 7.49579 14.9518 7.98071C14.8553 8.46563 14.6172 8.91105 14.2676 9.26066C13.918 9.61027 13.4726 9.84835 12.9877 9.94481C12.5028 10.0413 12.0001 9.99176 11.5434 9.80256C11.0866 9.61335 10.6962 9.29294 10.4215 8.88185C10.1468 8.47075 10.0002 7.98744 10.0002 7.49302C10.0002 6.83002 10.2635 6.19418 10.7324 5.72538C11.2012 5.25657 11.837 4.99319 12.5 4.99319ZM6.47542 13.7426H11.2501V18.7422H7.31286L6.47542 13.7426Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Manage Agency
              </Accordion.Header>
              <Accordion.Body className="py-0">
                <ul className="list-unstyled ps-5 mb-0">
                  <li className="">
                    <NavLink
                      to="/manage-agency/registered-agency"
                      className={`${styles.subLinks} ${pageActive.includes("/registered-agency") &&
                        styles.active
                        } text-white`}
                    >
                      Registered Agency
                    </NavLink>
                  </li>
                  <li className="">
                    <NavLink
                      to="/manage-agency/agency-request"
                      className={`${styles.subLinks} ${pageActive.includes("/agency-request") && styles.active
                        } text-white`}
                    >
                      New Agency Request
                    </NavLink>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </li>
          <li className="">
            <Accordion.Item
              className={`${styles.accordionWrp} border-0 bg-transparent`}
              eventKey="1"
            >
              <Accordion.Header
                className={`${styles.accordionBtn} fw-bold d-flex align-items-center gap-10`}
              >
                <span className={`${styles.icn} ${styles.fill} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 25 25"
                    fill="none"
                  >
                    <path
                      d="M7.60034 12.876C7.86492 13.7355 9.20399 13.7352 9.46847 12.876C8.86124 12.967 8.20752 12.967 7.60034 12.876Z"
                      fill="white"
                    />
                    <path
                      d="M15.1415 11.4293C14.6625 11.0407 14.1115 10.7375 13.5117 10.543C12.8487 11.3735 11.9826 12.035 10.9893 12.4518C11.0283 15.7968 6.0395 15.7952 6.07922 12.4518C5.08601 12.035 4.21986 11.3735 3.55688 10.543C0.762405 11.4041 -0.24274 14.2092 0.04835 16.9767C0.0481551 17.3803 0.375357 17.7075 0.779072 17.7076L10.8037 17.7091C11.0685 14.9517 12.7663 12.6065 15.1415 11.4293Z"
                      fill="white"
                    />
                    <path
                      d="M18.6149 16.8672C16.484 16.9054 16.4843 20.0721 18.6149 20.11C20.7457 20.0718 20.7453 16.9051 18.6149 16.8672Z"
                      fill="white"
                    />
                    <path
                      d="M24.9586 17.7578H21.6108C21.727 18.2233 21.727 18.7544 21.6108 19.2198H24.9586C25.014 18.7416 25.014 18.236 24.9586 17.7578Z"
                      fill="white"
                    />
                    <path
                      d="M18.6147 12.1035C15.864 12.1035 13.5139 13.8519 12.6174 16.2958H16.4492C17.5406 15.1262 19.6888 15.1264 20.7801 16.2958H24.6119C23.7155 13.8519 21.3654 12.1035 18.6147 12.1035Z"
                      fill="white"
                    />
                    <path
                      d="M15.5315 18.4888C15.5315 18.2371 15.5618 17.9922 15.619 17.7578H12.2712C12.2159 18.236 12.2159 18.7416 12.2712 19.2198H15.619C15.5619 18.9854 15.5315 18.7406 15.5315 18.4888Z"
                      fill="white"
                    />
                    <path
                      d="M16.4219 24.4858V20.6816H12.6177C13.2632 22.4413 14.6622 23.8404 16.4219 24.4858Z"
                      fill="white"
                    />
                    <path
                      d="M20.8079 24.4858C22.5675 23.8404 23.9666 22.4413 24.6121 20.6816H20.8079V24.4858Z"
                      fill="white"
                    />
                    <path
                      d="M17.8838 21.4844V24.8322C18.362 24.8875 18.8676 24.8875 19.3458 24.8322V21.4844C18.8804 21.6006 18.3493 21.6006 17.8838 21.4844Z"
                      fill="white"
                    />
                    <path
                      d="M5.32765 2.96536C5.54135 3.03724 12.5015 2.7713 12.4071 3.166C12.407 3.16605 13.3841 4.09317 13.3841 4.09317C12.6088 -1.46464 4.23888 -1.32019 3.66138 4.26817C3.98585 4.03654 4.87062 2.90035 5.32765 2.96536Z"
                      fill="white"
                    />
                    <path
                      d="M8.53426 11.4831C11.4072 11.4957 13.6402 9.00403 13.4388 6.16082L11.6122 4.42773H5.61897L3.62979 6.31258C3.49245 9.10657 5.7276 11.4915 8.53426 11.4831Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Manage Drivers
              </Accordion.Header>
              <Accordion.Body className="py-0">
                <ul className="list-unstyled ps-5 mb-0">
                  <li className="">
                    <NavLink
                      to="/manage-driver/registered-driver"
                      className={`${styles.subLinks} ${pageActive.includes("/registered-driver") &&
                        styles.active
                        } text-white`}
                    >
                      Registered Driver
                    </NavLink>
                  </li>
                  <li className="">
                    <NavLink
                      to="manage-driver/driver-request"
                      className={`${styles.subLinks} ${pageActive.includes("/driver-request") && styles.active
                        } text-white`}
                    >
                      New Driver Request
                    </NavLink>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </li>
          <li className="">
            <NavLink
              to="/dispute-management"
              className={`${styles.link} ${pageActive.includes("/dispute-management") && styles.active
                } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <path
                    d="M12.0222 14.5473L13.1735 11.861C13.3328 11.4892 13.1606 11.0586 12.7888 10.8992C12.417 10.7399 11.9864 10.9121 11.8271 11.2839L10.3622 14.7019C10.1934 15.0957 10.3973 15.5497 10.8038 15.6852L12.9784 16.4101L11.8271 19.0964C11.6678 19.4682 11.84 19.8988 12.2118 20.0581C12.5836 20.2175 13.0141 20.0452 13.1735 19.6735L14.6383 16.2555C14.8071 15.8616 14.6033 15.4076 14.1967 15.2721L12.0222 14.5473Z"
                    fill="white"
                  />
                  <path
                    d="M19.1406 13.5254C17.6598 13.5254 16.4551 14.7301 16.4551 16.2109C16.4551 17.6917 17.6598 18.8965 19.1406 18.8965C20.6214 18.8965 21.8262 17.6917 21.8262 16.2109C21.8262 14.7301 20.6214 13.5254 19.1406 13.5254Z"
                    fill="white"
                  />
                  <path
                    d="M22.0412 19.1758C21.2924 19.9086 20.2687 20.3615 19.1406 20.3615C18.0126 20.3615 16.9889 19.9086 16.24 19.1758C14.4727 20.1847 13.2812 22.087 13.2812 24.2678C13.2812 24.6723 13.6092 25.0002 14.0137 25.0002H24.2676C24.6721 25.0002 25 24.6723 25 24.2678C25 22.087 23.8086 20.1847 22.0412 19.1758Z"
                    fill="white"
                  />
                  <path
                    d="M5.85938 13.5254C4.37856 13.5254 3.17383 14.7301 3.17383 16.2109C3.17383 17.6917 4.37856 18.8965 5.85938 18.8965C7.34019 18.8965 8.54492 17.6917 8.54492 16.2109C8.54492 14.7301 7.34019 13.5254 5.85938 13.5254Z"
                    fill="white"
                  />
                  <path
                    d="M8.75996 19.1758C8.01113 19.9086 6.9874 20.3615 5.85938 20.3615C4.73135 20.3615 3.70762 19.9086 2.95879 19.1758C1.19141 20.1847 0 22.087 0 24.2678C0 24.6723 0.32793 25.0002 0.732422 25.0002H10.9863C11.3908 25.0002 11.7188 24.6723 11.7188 24.2678C11.7188 22.087 10.5273 20.1847 8.75996 19.1758Z"
                    fill="white"
                  />
                  <path
                    d="M24.2676 0H14.0137C13.6092 0 13.2812 0.32793 13.2812 0.732422V8.54492C13.2812 8.94941 13.6092 9.27734 14.0137 9.27734H15.9076L18.6228 11.9925C19.0841 12.4539 19.873 12.1271 19.873 11.4746V9.27734H24.2676C24.6721 9.27734 25 8.94941 25 8.54492V0.732422C25 0.32793 24.6721 0 24.2676 0ZM21.3379 5.37109H16.9434C16.5389 5.37109 16.2109 5.04316 16.2109 4.63867C16.2109 4.23418 16.5389 3.90625 16.9434 3.90625H21.3379C21.7424 3.90625 22.0703 4.23418 22.0703 4.63867C22.0703 5.04316 21.7424 5.37109 21.3379 5.37109Z"
                    fill="white"
                  />
                  <path
                    d="M0 0.732422V8.54492C0 8.94941 0.32793 9.27734 0.732422 9.27734H5.12695V11.4746C5.12695 12.1271 5.91587 12.4539 6.37729 11.9925L9.09243 9.27734H10.9863C11.3908 9.27734 11.7188 8.94941 11.7188 8.54492V0.732422C11.7188 0.32793 11.3908 0 10.9863 0H0.732422C0.32793 0 0 0.32793 0 0.732422ZM2.92969 4.63867C2.92969 4.23418 3.25762 3.90625 3.66211 3.90625H8.05664C8.46113 3.90625 8.78906 4.23418 8.78906 4.63867C8.78906 5.04316 8.46113 5.37109 8.05664 5.37109H3.66211C3.25762 5.37109 2.92969 5.04316 2.92969 4.63867Z"
                    fill="white"
                  />
                </svg>
              </span>
              Dispute Management
            </NavLink>
          </li>
          <li className="">
            <NavLink
              to="/vehicle"
              className={`${styles.link} ${pageActive.includes("/vehicle") && styles.active
                } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <path
                    d="M22.1285 13.1964C22.1285 12.9524 22.1285 12.7202 22.1285 12.5C22.1285 12.2798 22.1285 12.0476 22.1285 11.8036L24.3428 9.6608C24.486 9.52223 24.5788 9.33971 24.6063 9.14232C24.6338 8.94492 24.5944 8.744 24.4945 8.57155L21.816 3.92883C21.7163 3.75682 21.5621 3.62301 21.3777 3.54861C21.1933 3.47421 20.9894 3.46349 20.7982 3.51813L17.8251 4.36632C17.4438 4.10534 17.0439 3.87259 16.6287 3.66991L15.8787 0.67893C15.8298 0.480832 15.7146 0.305454 15.5521 0.181993C15.3897 0.0585317 15.1898 -0.00556319 14.9859 0.000378927H9.62891C9.42496 -0.00556319 9.22513 0.0585317 9.06268 0.181993C8.90023 0.305454 8.78497 0.480832 8.73608 0.67893L7.98611 3.66991C7.57087 3.87259 7.17101 4.10534 6.78971 4.36632L3.84338 3.51813C3.65221 3.46349 3.44828 3.47421 3.2639 3.54861C3.07952 3.62301 2.92526 3.75682 2.82555 3.92883L0.147059 8.57155C0.0471551 8.744 0.00782425 8.94492 0.03533 9.14232C0.0628358 9.33971 0.155596 9.52223 0.29884 9.6608L2.48627 11.8036C2.48627 12.0417 2.48627 12.2738 2.48627 12.5C2.48627 12.7262 2.48627 12.9583 2.48627 13.1964L0.272055 15.3392C0.128811 15.4778 0.0360509 15.6603 0.00854514 15.8577C-0.0189606 16.0551 0.02037 16.256 0.120274 16.4285L2.79876 21.0712C2.89847 21.2432 3.05274 21.377 3.23712 21.4514C3.42149 21.5258 3.62543 21.5365 3.81659 21.4819L6.78971 20.6337C7.17101 20.8947 7.57087 21.1274 7.98611 21.3301L8.73608 24.3211C8.78497 24.5192 8.90023 24.6945 9.06268 24.818C9.22513 24.9415 9.42496 25.0056 9.62891 24.9996H14.9859C15.1898 25.0056 15.3897 24.9415 15.5521 24.818C15.7146 24.6945 15.8298 24.5192 15.8787 24.3211L16.6287 21.3301C17.0439 21.1274 17.4438 20.8947 17.8251 20.6337L20.7982 21.4819C20.9894 21.5365 21.1933 21.5258 21.3777 21.4514C21.5621 21.377 21.7163 21.2432 21.816 21.0712L24.4945 16.4285C24.5944 16.256 24.6338 16.0551 24.6063 15.8577C24.5788 15.6603 24.486 15.4778 24.3428 15.3392L22.1285 13.1964ZM13.2002 16.9642V17.857C13.2002 18.0938 13.1062 18.3209 12.9387 18.4883C12.7713 18.6557 12.5442 18.7498 12.3074 18.7498C12.0706 18.7498 11.8435 18.6557 11.6761 18.4883C11.5086 18.3209 11.4146 18.0938 11.4146 17.857V16.9642C10.9456 16.9629 10.4852 16.8385 10.0794 16.6035C9.67361 16.3685 9.33662 16.031 9.10214 15.6249C9.02867 15.5239 8.97721 15.4085 8.9511 15.2864C8.92499 15.1642 8.92481 15.0379 8.95057 14.9157C8.97633 14.7934 9.02746 14.678 9.10065 14.5767C9.17384 14.4755 9.26746 14.3907 9.37546 14.3279C9.48346 14.2651 9.60344 14.2257 9.72763 14.2122C9.85183 14.1987 9.97747 14.2114 10.0965 14.2495C10.2154 14.2876 10.3251 14.3502 10.4183 14.4333C10.5116 14.5165 10.5864 14.6182 10.6378 14.7321C10.7165 14.8683 10.8297 14.9814 10.9661 15.0598C11.1026 15.1382 11.2572 15.1791 11.4146 15.1785H13.2002C13.437 15.1785 13.6641 15.0844 13.8316 14.917C13.999 14.7495 14.0931 14.5225 14.0931 14.2857C14.0931 14.0489 13.999 13.8218 13.8316 13.6543C13.6641 13.4869 13.437 13.3928 13.2002 13.3928H11.4146C10.7042 13.3928 10.0229 13.1106 9.5206 12.6083C9.01828 12.106 8.73608 11.4247 8.73608 10.7143C8.73608 10.004 9.01828 9.32267 9.5206 8.82036C10.0229 8.31805 10.7042 8.03585 11.4146 8.03585V7.14302C11.4146 6.90623 11.5086 6.67913 11.6761 6.51169C11.8435 6.34426 12.0706 6.25019 12.3074 6.25019C12.5442 6.25019 12.7713 6.34426 12.9387 6.51169C13.1062 6.67913 13.2002 6.90623 13.2002 7.14302V8.03585C13.6692 8.03711 14.1296 8.16148 14.5354 8.3965C14.9412 8.63152 15.2782 8.96897 15.5127 9.37509C15.5861 9.47613 15.6376 9.59146 15.6637 9.71363C15.6898 9.8358 15.69 9.96208 15.6642 10.0843C15.6385 10.2066 15.5874 10.322 15.5142 10.4233C15.441 10.5245 15.3474 10.6093 15.2394 10.6721C15.1313 10.7349 15.0114 10.7743 14.8872 10.7878C14.763 10.8013 14.6373 10.7886 14.5184 10.7505C14.3994 10.7124 14.2897 10.6498 14.1965 10.5667C14.1032 10.4835 14.0284 10.3818 13.977 10.2679C13.8983 10.1317 13.7851 10.0186 13.6487 9.94024C13.5123 9.86184 13.3576 9.82088 13.2002 9.82151H11.4146C11.1778 9.82151 10.9507 9.91558 10.7832 10.083C10.6158 10.2505 10.5217 10.4775 10.5217 10.7143C10.5217 10.9511 10.6158 11.1782 10.7832 11.3457C10.9507 11.5131 11.1778 11.6072 11.4146 11.6072H13.2002C13.9106 11.6072 14.5919 11.8894 15.0942 12.3917C15.5965 12.894 15.8787 13.5753 15.8787 14.2857C15.8787 14.996 15.5965 15.6773 15.0942 16.1796C14.5919 16.682 13.9106 16.9642 13.2002 16.9642Z"
                    fill="white"
                  />
                </svg>
              </span>
              Vehicles
            </NavLink>
          </li>


          <li className="">
            <Accordion.Item
              className={`${styles.accordionWrp} border-0 bg-transparent`}
              eventKey="5"
            >
              <Accordion.Header
                className={`${styles.accordionBtn} rotateIcon fw-bold d-flex align-items-center gap-10`}
              >
                <span className={`${styles.icn} ${styles.fill} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 25 25"
                    fill="none"
                  >
                    <path
                      d="M7.60034 12.876C7.86492 13.7355 9.20399 13.7352 9.46847 12.876C8.86124 12.967 8.20752 12.967 7.60034 12.876Z"
                      fill="white"
                    />
                    <path
                      d="M15.1415 11.4293C14.6625 11.0407 14.1115 10.7375 13.5117 10.543C12.8487 11.3735 11.9826 12.035 10.9893 12.4518C11.0283 15.7968 6.0395 15.7952 6.07922 12.4518C5.08601 12.035 4.21986 11.3735 3.55688 10.543C0.762405 11.4041 -0.24274 14.2092 0.04835 16.9767C0.0481551 17.3803 0.375357 17.7075 0.779072 17.7076L10.8037 17.7091C11.0685 14.9517 12.7663 12.6065 15.1415 11.4293Z"
                      fill="white"
                    />
                    <path
                      d="M18.6149 16.8672C16.484 16.9054 16.4843 20.0721 18.6149 20.11C20.7457 20.0718 20.7453 16.9051 18.6149 16.8672Z"
                      fill="white"
                    />
                    <path
                      d="M24.9586 17.7578H21.6108C21.727 18.2233 21.727 18.7544 21.6108 19.2198H24.9586C25.014 18.7416 25.014 18.236 24.9586 17.7578Z"
                      fill="white"
                    />
                    <path
                      d="M18.6147 12.1035C15.864 12.1035 13.5139 13.8519 12.6174 16.2958H16.4492C17.5406 15.1262 19.6888 15.1264 20.7801 16.2958H24.6119C23.7155 13.8519 21.3654 12.1035 18.6147 12.1035Z"
                      fill="white"
                    />
                    <path
                      d="M15.5315 18.4888C15.5315 18.2371 15.5618 17.9922 15.619 17.7578H12.2712C12.2159 18.236 12.2159 18.7416 12.2712 19.2198H15.619C15.5619 18.9854 15.5315 18.7406 15.5315 18.4888Z"
                      fill="white"
                    />
                    <path
                      d="M16.4219 24.4858V20.6816H12.6177C13.2632 22.4413 14.6622 23.8404 16.4219 24.4858Z"
                      fill="white"
                    />
                    <path
                      d="M20.8079 24.4858C22.5675 23.8404 23.9666 22.4413 24.6121 20.6816H20.8079V24.4858Z"
                      fill="white"
                    />
                    <path
                      d="M17.8838 21.4844V24.8322C18.362 24.8875 18.8676 24.8875 19.3458 24.8322V21.4844C18.8804 21.6006 18.3493 21.6006 17.8838 21.4844Z"
                      fill="white"
                    />
                    <path
                      d="M5.32765 2.96536C5.54135 3.03724 12.5015 2.7713 12.4071 3.166C12.407 3.16605 13.3841 4.09317 13.3841 4.09317C12.6088 -1.46464 4.23888 -1.32019 3.66138 4.26817C3.98585 4.03654 4.87062 2.90035 5.32765 2.96536Z"
                      fill="white"
                    />
                    <path
                      d="M8.53426 11.4831C11.4072 11.4957 13.6402 9.00403 13.4388 6.16082L11.6122 4.42773H5.61897L3.62979 6.31258C3.49245 9.10657 5.7276 11.4915 8.53426 11.4831Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Manage Vendors
              </Accordion.Header>
              <Accordion.Body className="py-0">
                <ul className="list-unstyled ps-5 mb-0">
                  <li className="">
                    <NavLink
                      to="/vendors"
                      className={`${styles.subLinks} ${pageActive.includes("/vendors") &&
                        styles.active
                        } text-white`}
                    >
                      Vendors Listing
                    </NavLink>
                  </li>
                  <li className="">
                    <NavLink
                      to="/guest-booking"
                      className={`${styles.subLinks} ${pageActive.includes("/guest-booking") && styles.active
                        } text-white`}
                    >
                      Vendors Bookings
                    </NavLink>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </li>
          {/* <li className="">
            <NavLink
              to="/fare-request"
              className={`${styles.link} ${
                pageActive.includes("/fare-request") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 22 25"
                  fill="none"
                >
                  <path d="M4.39453 7.32422H5.85938V8.78906H4.39453V7.32422Z" fill="white" />
                  <path
                    d="M19.7754 0H2.19727C0.985645 0 0 0.985645 0 2.19727V10.9863C0 12.1979 0.985645 13.1836 2.19727 13.1836H8.05664V8.78906H19.043V10.2539H13.916V13.1836H19.7754C20.987 13.1836 21.9727 12.1979 21.9727 10.9863V2.19727C21.9727 0.985645 20.987 0 19.7754 0ZM7.32422 10.2539H2.92969V5.85938H7.32422V10.2539ZM19.043 7.32422H8.78906V5.85938H19.043V7.32422ZM19.043 4.39453H2.92969V2.92969H19.043V4.39453Z"
                    fill="white"
                  />
                  <path
                    d="M10.9864 25V23.5352L8.07098 21.6018C7.71048 21.3586 7.47659 20.9645 7.43367 20.5239C7.39148 20.0833 7.54383 19.6542 7.8514 19.3459L9.52151 17.6758V10.2539H12.4512V16.2109H15.3809C16.1884 16.2109 16.8457 16.8683 16.8457 17.6758V25H10.9864Z"
                    fill="white"
                  />
                </svg>
              </span>
              Fare Requests
            </NavLink>
          </li> */}
          <li className="">
            <NavLink
              to="/manage-booking"
              className={`${styles.link} ${pageActive.includes("/manage-booking") && styles.active
                } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 16 25"
                  fill="none"
                >
                  <path
                    d="M0 23.6604C0 24.4001 0.59967 24.9998 1.33926 24.9998H13.8393C14.579 24.9998 15.1784 24.4001 15.1784 23.6604V22.3213H0V23.6604ZM11.6071 23.2142H12.5C12.7466 23.2142 12.9465 23.4141 12.9465 23.6604C12.9465 23.9071 12.7466 24.107 12.5 24.107H11.6071C11.3605 24.107 11.1606 23.9071 11.1606 23.6604C11.1606 23.4141 11.3605 23.2142 11.6071 23.2142ZM7.14279 23.2142H8.03558C8.28217 23.2142 8.48206 23.4141 8.48206 23.6604C8.48206 23.9071 8.28217 24.107 8.03558 24.107H7.14279C6.89621 24.107 6.69647 23.9071 6.69647 23.6604C6.69647 23.4141 6.89621 23.2142 7.14279 23.2142ZM2.67838 23.2142H3.57147C3.8179 23.2142 4.01779 23.4141 4.01779 23.6604C4.01779 23.9071 3.8179 24.107 3.57147 24.107H2.67838C2.43195 24.107 2.23206 23.9071 2.23206 23.6604C2.23206 23.4141 2.43195 23.2142 2.67838 23.2142Z"
                    fill="white"
                  />
                  <path
                    d="M11.6071 8.92874C11.6071 8.68231 11.4072 8.48242 11.1606 8.48242H10.2678C10.2678 8.729 10.0679 8.92874 9.82147 8.92874C9.57489 8.92874 9.375 8.729 9.375 8.48242H5.80338C5.80338 8.729 5.60379 8.92874 5.35706 8.92874C5.11047 8.92874 4.91058 8.729 4.91058 8.48242H4.01779C3.77121 8.48242 3.57147 8.68231 3.57147 8.92874V9.82169H11.6071V8.92874Z"
                    fill="white"
                  />
                  <path
                    d="M4.01779 16.5182H11.1606C11.4072 16.5182 11.6071 16.3183 11.6071 16.0719V10.7148H3.57147V16.0719C3.57147 16.3183 3.77121 16.5182 4.01779 16.5182ZM5.0415 13.9706C5.21576 13.7962 5.4985 13.7962 5.67276 13.9706L6.25 14.5479L9.50577 11.2919C9.68094 11.1227 9.95941 11.1253 10.1315 11.2974C10.3038 11.4695 10.3061 11.748 10.1369 11.9233L6.56555 15.4945C6.3913 15.6689 6.10855 15.6689 5.9343 15.4945L5.0415 14.6017C4.8671 14.4275 4.8671 14.1447 5.0415 13.9706Z"
                    fill="white"
                  />
                  <path
                    d="M0 21.4285H15.1784V3.125H0V21.4285ZM11.1606 20.5356H5.80338C5.55695 20.5356 5.35706 20.3357 5.35706 20.0894C5.35706 19.8427 5.55695 19.6428 5.80338 19.6428H11.1606C11.4072 19.6428 11.6071 19.8427 11.6071 20.0894C11.6071 20.3357 11.4072 20.5356 11.1606 20.5356ZM12.9465 19.6428H13.8393C14.0857 19.6428 14.2856 19.8427 14.2856 20.0894C14.2856 20.3357 14.0857 20.5356 13.8393 20.5356H12.9465C12.6999 20.5356 12.5 20.3357 12.5 20.0894C12.5 19.8427 12.6999 19.6428 12.9465 19.6428ZM4.01779 4.01779H9.375C9.62158 4.01779 9.82147 4.21768 9.82147 4.46442C9.82147 4.71069 9.62158 4.91058 9.375 4.91058H4.01779C3.77121 4.91058 3.57147 4.71069 3.57147 4.46442C3.57147 4.21768 3.77121 4.01779 4.01779 4.01779ZM4.01779 7.58942H4.91058V7.14279C4.91058 6.89621 5.11047 6.69647 5.35706 6.69647C5.60379 6.69647 5.80338 6.89621 5.80338 7.14279V7.58942H9.375V7.14279C9.375 6.89621 9.57489 6.69647 9.82147 6.69647C10.0679 6.69647 10.2678 6.89621 10.2678 7.14279V7.58942H11.1606C11.9003 7.58942 12.5 8.18878 12.5 8.92853V16.0715C12.5 16.8112 11.9003 17.4106 11.1606 17.4106H4.01779C3.27805 17.4106 2.67838 16.8112 2.67838 16.0715V8.92853C2.67838 8.18878 3.27805 7.58942 4.01779 7.58942ZM1.33926 4.01779H2.23206C2.47879 4.01779 2.67838 4.21768 2.67838 4.46442C2.67838 4.71069 2.47879 4.91058 2.23206 4.91058H1.33926C1.09268 4.91058 0.892792 4.71069 0.892792 4.46442C0.892792 4.21768 1.09268 4.01779 1.33926 4.01779Z"
                    fill="white"
                  />
                  <path
                    d="M13.8393 0H8.03558V0.446472C8.03558 0.692902 7.83569 0.892792 7.58926 0.892792C7.34268 0.892792 7.14279 0.692902 7.14279 0.446472V0H1.33926C0.59967 0 0 0.59967 0 1.33942V2.23221H15.1784V1.33942C15.1784 0.59967 14.579 0 13.8393 0Z"
                    fill="white"
                  />
                </svg>
              </span>
              Manage Booking
            </NavLink>
          </li>



          <li className="">
            <NavLink
              to="/bird-eye-view"
              className={`${styles.link} ${pageActive.includes("/bird-eye-view") && styles.active
                } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <path
                    d="M6.2689 13.2598H5.14776C4.85365 13.2598 4.58814 13.4349 4.4718 13.7046L1.36816 20.9313L8.73891 17.1668C7.85657 15.9459 6.98358 14.5993 6.2689 13.2598Z"
                    fill="white"
                  />
                  <path
                    d="M20.5284 13.7046C20.4123 13.4349 20.1466 13.2598 19.8526 13.2598H18.7315C17.3819 15.7889 15.4156 18.4025 14.1647 19.8405C13.2851 20.8495 11.7138 20.8483 10.8355 19.8405C10.7456 19.7373 10.2766 19.1943 9.63061 18.3592L8.30176 19.0383L13.3284 24.0551L22.8529 19.1174L20.5284 13.7046Z"
                    fill="white"
                  />
                  <path
                    d="M0.461003 23.0434L0.0600788 23.977C-0.14744 24.4602 0.208089 24.9998 0.735851 24.9998H11.5293C11.5968 24.9496 11.5976 24.9527 11.96 24.7648L6.92595 19.7412L0.461003 23.0434Z"
                    fill="white"
                  />
                  <path
                    d="M24.9395 23.9775L23.4335 20.4707L14.6963 25.0003H24.2637C24.7903 25.0003 25.1474 24.4616 24.9395 23.9775Z"
                    fill="white"
                  />
                  <path
                    d="M13.2352 6.60778C13.2352 6.20304 12.9052 5.87402 12.4999 5.87402C12.0944 5.87402 11.7646 6.20304 11.7646 6.60778C11.7646 7.01233 12.0944 7.34153 12.4999 7.34153C12.9052 7.34153 13.2352 7.01233 13.2352 6.60778Z"
                    fill="white"
                  />
                  <path
                    d="M13.055 18.8289C13.3026 18.5448 19.1175 11.8183 19.1175 7.19452C19.1175 -2.33991 5.88281 -2.45626 5.88281 7.19452C5.88281 11.8183 11.6977 18.5448 11.9453 18.8289C12.2385 19.1652 12.7624 19.1648 13.055 18.8289ZM10.2943 6.60763C10.2943 5.3938 11.2838 4.40637 12.5002 4.40637C13.7163 4.40637 14.7058 5.3938 14.7058 6.60763C14.7058 7.82128 13.7163 8.80871 12.5002 8.80871C11.2838 8.80871 10.2943 7.82128 10.2943 6.60763Z"
                    fill="white"
                  />
                </svg>
              </span>
              Bird Eye View
            </NavLink>
          </li>
          <li className="">
            <NavLink
              to="/promotions"
              className={`${styles.link} ${pageActive.includes("/promotions") && styles.active
                } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <path
                    d="M23.6243 14.3182L22.711 12.9147C22.5469 12.6629 22.5469 12.3373 22.711 12.0849L23.6247 10.6809C24.4565 9.40029 23.8936 7.68493 22.4742 7.14245L20.9108 6.54348C20.6298 6.43587 20.438 6.1722 20.4226 5.872L20.3365 4.20004C20.2586 2.67979 18.7996 1.61779 17.3256 2.01222L15.7091 2.44703C15.4196 2.52486 15.1083 2.42472 14.9197 2.19074L13.8669 0.8885C12.9087 -0.297281 11.1004 -0.295328 10.1452 0.88933L9.09233 2.19083C8.90376 2.42486 8.59297 2.5255 8.30347 2.44713L6.68698 2.01261C5.21698 1.61667 3.75361 2.67794 3.67553 4.20014L3.5895 5.87239C3.57412 6.17254 3.38286 6.43601 3.10186 6.54358L1.53849 7.14206C0.117263 7.6863 -0.443817 9.40244 0.388403 10.6821L1.30099 12.0845C1.46515 12.3368 1.46515 12.663 1.30153 12.9148L0.388403 14.3183C-0.443426 15.595 0.116384 17.3143 1.53849 17.8577L3.10186 18.4564C3.38286 18.5642 3.57412 18.8277 3.5895 19.1279L3.67553 20.8001C3.75346 22.3202 5.2137 23.3828 6.68698 22.9877L8.30347 22.5526C8.59249 22.475 8.90269 22.5749 9.09287 22.8098L10.1452 24.1113C11.1015 25.2946 12.9069 25.2977 13.8674 24.1118L14.9198 22.8098C15.1094 22.575 15.4191 22.4756 15.7086 22.5526L17.3267 22.9882C18.794 23.3815 20.2585 22.3245 20.3365 20.8001L20.4226 19.1284C20.4379 18.8278 20.6297 18.5642 20.9108 18.4564L22.4742 17.8582C23.8949 17.3142 24.4566 15.5979 23.6243 14.3182ZM8.70611 8.10299C9.606 8.10299 10.338 8.83502 10.338 9.73486C10.338 10.6348 9.60595 11.3667 8.70611 11.3667C7.80621 11.3667 7.07424 10.6347 7.07424 9.73486C7.07424 8.83502 7.80626 8.10299 8.70611 8.10299ZM14.6897 17.3504C13.7898 17.3504 13.0578 16.6183 13.0578 15.7185C13.0578 14.8186 13.7899 14.0866 14.6897 14.0866C15.5896 14.0866 16.3216 14.8187 16.3216 15.7185C16.3216 16.6184 15.5896 17.3504 14.6897 17.3504ZM16.0826 9.49585L8.4671 17.1113C8.14835 17.4301 7.63204 17.4301 7.3133 17.1113C6.9946 16.7926 6.9946 16.2762 7.3133 15.9575L14.9288 8.34205C15.2475 8.02335 15.7639 8.02335 16.0826 8.34205C16.4013 8.66075 16.4013 9.1771 16.0826 9.49585Z"
                    fill="white"
                  />
                </svg>
              </span>
              Promotions
            </NavLink>
          </li>
          <li className="">
            <NavLink
              to="/promocodes"
              className={`${styles.link} ${pageActive.includes("/promocodes") && styles.active
                } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 25 18"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.54298 16.8791C1.54298 17.2226 1.82409 17.5037 2.16767 17.5037H18.1222C18.2909 17.5037 18.447 17.435 18.5657 17.3226L18.7469 17.1414L18.928 17.3226C19.0467 17.4413 19.2029 17.5037 19.3716 17.5037H22.8323C23.1759 17.5037 23.457 17.2226 23.457 16.8791C23.457 16.6354 23.5507 16.4043 23.7256 16.2294C23.9006 16.0607 24.1317 15.9608 24.3753 15.9608C24.544 15.9608 24.7002 15.8921 24.8188 15.7796C24.9375 15.6609 25 15.5047 25 15.3361V13.7494C25 13.5807 24.9313 13.4245 24.8188 13.3058L24.6377 13.1247L24.8188 12.9435C24.9375 12.8248 25 12.6687 25 12.5V10.6259C25 10.2824 24.7189 10.0013 24.3753 10.0013C24.3753 10.0013 23.1259 10.0013 23.1259 8.75187C23.1259 7.5025 24.3753 7.5025 24.3753 7.5025C24.7189 7.5025 25 7.22139 25 6.87781V5.00375C25 4.83508 24.9313 4.67891 24.8188 4.56022L24.6377 4.37906L24.8188 4.1979C24.9375 4.07921 25 3.92304 25 3.75437V2.16767C25 2.00525 24.9313 1.84283 24.8188 1.72414C24.7002 1.60545 24.544 1.54298 24.3753 1.54298C24.1317 1.54298 23.9006 1.44928 23.7256 1.27436C23.557 1.09945 23.457 0.868316 23.457 0.624688C23.457 0.281109 23.1759 0 22.8323 0H19.3716C19.2029 0 19.0467 0.0687162 18.928 0.18116L18.7469 0.362319L18.5657 0.18116C18.447 0.0624693 18.2909 0 18.1222 0H2.16767C1.82409 0 1.54298 0.281109 1.54298 0.624688C1.54298 0.868316 1.44928 1.09945 1.27436 1.27436C1.09945 1.44303 0.868316 1.54298 0.624688 1.54298C0.456022 1.54298 0.29985 1.61169 0.18116 1.72414C0.0624689 1.84283 0 1.999 0 2.16767V15.3298C0 15.4923 0.0687158 15.6547 0.18116 15.7734C0.29985 15.8921 0.456022 15.9545 0.624688 15.9545C0.868316 15.9545 1.09945 16.0482 1.27436 16.2231C1.44303 16.3981 1.54298 16.6292 1.54298 16.8728V16.8791ZM16.8728 13.1309C16.8728 12.7874 16.5917 12.5062 16.2481 12.5062H3.75437C3.4108 12.5062 3.12969 12.7874 3.12969 13.1309V15.005C3.12969 15.3486 3.4108 15.6297 3.75437 15.6297H16.2481C16.5917 15.6297 16.8728 15.3486 16.8728 15.005V13.1309ZM18.1222 13.1309V14.3803C18.1222 14.7239 18.4033 15.005 18.7469 15.005C19.0905 15.005 19.3716 14.7239 19.3716 14.3803V13.1309C19.3716 12.7874 19.0905 12.5062 18.7469 12.5062C18.4033 12.5062 18.1222 12.7874 18.1222 13.1309ZM15.6234 13.7556V14.3803H4.37906V13.7556H15.6234ZM18.1222 10.0075V11.2569C18.1222 11.6005 18.4033 11.8816 18.7469 11.8816C19.0905 11.8816 19.3716 11.6005 19.3716 11.2569V10.0075C19.3716 9.66392 19.0905 9.38281 18.7469 9.38281C18.4033 9.38281 18.1222 9.66392 18.1222 10.0075ZM15.3111 8.75812C14.449 8.75812 13.7494 9.45777 13.7494 10.3198C13.7494 11.1819 14.449 11.8816 15.3111 11.8816C16.1732 11.8816 16.8728 11.1819 16.8728 10.3198C16.8728 9.45777 16.1732 8.75812 15.3111 8.75812ZM14.5302 5.84708L10.1574 10.8446C9.93254 11.1007 9.95752 11.5005 10.2136 11.7254C10.4698 11.9503 10.8696 11.9253 11.0945 11.6692L15.4673 6.67167C15.6922 6.41554 15.6672 6.01574 15.411 5.79086C15.1549 5.56597 14.7551 5.59096 14.5302 5.84708ZM3.75437 11.2569H5.00375C5.34733 11.2569 5.62844 10.9758 5.62844 10.6322C5.62844 10.2886 5.34733 10.0075 5.00375 10.0075H3.75437C3.4108 10.0075 3.12969 10.2886 3.12969 10.6322C3.12969 10.9758 3.4108 11.2569 3.75437 11.2569ZM15.3111 10.0075C15.486 10.0075 15.6234 10.1449 15.6234 10.3198C15.6234 10.4948 15.486 10.6322 15.3111 10.6322C15.1362 10.6322 14.9988 10.4948 14.9988 10.3198C14.9988 10.1449 15.1362 10.0075 15.3111 10.0075ZM3.75437 9.38281H6.87781C7.22139 9.38281 7.5025 9.1017 7.5025 8.75812C7.5025 8.41454 7.22139 8.13343 6.87781 8.13343H3.75437C3.4108 8.13343 3.12969 8.41454 3.12969 8.75812C3.12969 9.1017 3.4108 9.38281 3.75437 9.38281ZM10.3136 5.63468C9.45153 5.63468 8.75187 6.33433 8.75187 7.1964C8.75187 8.05847 9.45153 8.75812 10.3136 8.75812C11.1757 8.75812 11.8753 8.05847 11.8753 7.1964C11.8753 6.33433 11.1757 5.63468 10.3136 5.63468ZM18.1222 6.25937V7.50875C18.1222 7.85232 18.4033 8.13343 18.7469 8.13343C19.0905 8.13343 19.3716 7.85232 19.3716 7.50875V6.25937C19.3716 5.91579 19.0905 5.63468 18.7469 5.63468C18.4033 5.63468 18.1222 5.91579 18.1222 6.25937ZM3.75437 7.50875H6.87781C7.22139 7.50875 7.5025 7.22764 7.5025 6.88406C7.5025 6.54048 7.22139 6.25937 6.87781 6.25937H3.75437C3.4108 6.25937 3.12969 6.54048 3.12969 6.88406C3.12969 7.22764 3.4108 7.50875 3.75437 7.50875ZM10.3136 6.88406C10.4885 6.88406 10.6259 7.02149 10.6259 7.1964C10.6259 7.37132 10.4885 7.50875 10.3136 7.50875C10.1387 7.50875 10.0013 7.37132 10.0013 7.1964C10.0013 7.02149 10.1387 6.88406 10.3136 6.88406ZM18.1222 3.13593V4.38531C18.1222 4.72889 18.4033 5.01 18.7469 5.01C19.0905 5.01 19.3716 4.72889 19.3716 4.38531V3.13593C19.3716 2.79235 19.0905 2.51125 18.7469 2.51125C18.4033 2.51125 18.1222 2.79235 18.1222 3.13593ZM16.8728 2.51125C16.8728 2.16767 16.5917 1.88656 16.2481 1.88656H3.75437C3.4108 1.88656 3.12969 2.16767 3.12969 2.51125V4.38531C3.12969 4.72889 3.4108 5.01 3.75437 5.01H16.2481C16.5917 5.01 16.8728 4.72889 16.8728 4.38531V2.51125ZM15.6234 3.13593V3.76062H4.37906V3.13593H15.6234Z"
                    fill="white"
                  />
                </svg>
              </span>
              Promo Codes
            </NavLink>
          </li>
          <li className="">
            <Accordion.Item
              className={`${styles.accordionWrp} border-0 bg-transparent`}
              eventKey="3"
            >
              <Accordion.Header
                className={`${styles.accordionBtn} fw-bold d-flex align-items-center gap-10`}
              >
                <span className={`${styles.icn} ${styles.fill} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 25 25"
                    fill="none"
                  >
                    <path
                      d="M23.7492 18.7422H20.2245L21.0619 13.7426H22.4993C22.7613 13.7433 23.017 13.6616 23.23 13.509C23.4431 13.3565 23.6029 13.1409 23.6867 12.8926L24.9366 9.1429C25.0231 8.88169 25.021 8.59923 24.9306 8.33934C24.8402 8.07945 24.6666 7.85665 24.4367 7.7055L13.1875 0.20603C12.9834 0.0716298 12.7444 0 12.5 0C12.2556 0 12.0166 0.0716298 11.8125 0.20603L0.563337 7.7055C0.333403 7.85665 0.159771 8.07945 0.0693742 8.33934C-0.0210228 8.59923 -0.0231328 8.88169 0.0633716 9.1429L1.31328 12.8926C1.39713 13.1409 1.55689 13.3565 1.76997 13.509C1.98304 13.6616 2.23866 13.7433 2.5007 13.7426H3.9381L4.77554 18.7422H1.25079C0.919291 18.7422 0.601371 18.8739 0.366967 19.1083C0.132563 19.3427 0.000876005 19.6606 0.000876005 19.9921V23.7419C0.000876005 24.0734 0.132563 24.3913 0.366967 24.6257C0.601371 24.8601 0.919291 24.9918 1.25079 24.9918H23.7492C24.0807 24.9918 24.3986 24.8601 24.633 24.6257C24.8674 24.3913 24.9991 24.0734 24.9991 23.7419V19.9921C24.9991 19.6606 24.8674 19.3427 24.633 19.1083C24.3986 18.8739 24.0807 18.7422 23.7492 18.7422ZM17.6871 18.7422H13.7499V13.7426H18.5246L17.6871 18.7422ZM12.5 4.99319C12.9944 4.99319 13.4777 5.13981 13.8888 5.41449C14.2999 5.68918 14.6203 6.07959 14.8095 6.53638C14.9987 6.99316 15.0482 7.49579 14.9518 7.98071C14.8553 8.46563 14.6172 8.91105 14.2676 9.26066C13.918 9.61027 13.4726 9.84835 12.9877 9.94481C12.5028 10.0413 12.0001 9.99176 11.5434 9.80256C11.0866 9.61335 10.6962 9.29294 10.4215 8.88185C10.1468 8.47075 10.0002 7.98744 10.0002 7.49302C10.0002 6.83002 10.2635 6.19418 10.7324 5.72538C11.2012 5.25657 11.837 4.99319 12.5 4.99319ZM6.47542 13.7426H11.2501V18.7422H7.31286L6.47542 13.7426Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Reports
              </Accordion.Header>
              <Accordion.Body className="py-0">
                <ul className="list-unstyled ps-5 mb-0">
                  <li className="">
                    <NavLink
                      to="/reports/driver-report"
                      className={`${styles.subLinks} ${pageActive.includes("/driver-report") && styles.active
                        } text-white`}
                    >
                      Driver Report
                    </NavLink>
                  </li>
                  <li className="">
                    <NavLink
                      to="/reports/booking-report"
                      className={`${styles.subLinks} ${pageActive.includes("/booking-report") && styles.active
                        } text-white`}
                    >
                      Booking Report
                    </NavLink>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </li>
          <li className="">
            <NavLink
              to="/transaction-history"
              className={`${styles.link} ${pageActive.includes("/transaction-history") && styles.active
                } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <g clip-path="url(#clip0_66_2653)">
                    <path
                      d="M6.5918 18.3105H11.8652V19.9707H6.5918V18.3105Z"
                      fill="white"
                    />
                    <path
                      d="M14.0137 0.431641V4.73633H18.2744L14.0137 0.431641Z"
                      fill="white"
                    />
                    <path
                      d="M6.5918 15.1855H11.8652V16.8457H6.5918V15.1855Z"
                      fill="white"
                    />
                    <path
                      d="M3.4668 15.1855H5.12695V16.8457H3.4668V15.1855Z"
                      fill="white"
                    />
                    <path
                      d="M11.8652 12.4023C11.8652 10.3828 13.5078 8.74023 15.5273 8.74023H18.7012V6.20117H13.2812C12.877 6.20117 12.5488 5.87305 12.5488 5.46875V0H2.19727C0.98584 0 0 0.98584 0 2.19727V21.1914C0 22.4028 0.98584 23.3887 2.19727 23.3887H11.9126C11.8813 23.1978 11.8652 23.002 11.8652 22.8027V21.4355H2.73438C2.33008 21.4355 2.00195 21.1074 2.00195 20.7031V14.4531C2.00195 14.0488 2.33008 13.7207 2.73438 13.7207H11.8652V12.4023ZM6.43213 8.51709C6.29883 9.31055 5.74854 9.94141 5.02686 10.2012C5.00391 10.5845 4.68604 10.8887 4.29688 10.8887C3.93652 10.8887 3.63721 10.6279 3.57666 10.2852C3.23438 10.2266 2.92334 10.1006 2.5293 9.84277C2.19092 9.62109 2.0957 9.16748 2.31738 8.82861C2.53857 8.49023 2.99268 8.39551 3.33105 8.6167C3.68799 8.85059 3.80371 8.86865 4.29199 8.86523C4.76318 8.8623 4.95068 8.49219 4.9873 8.27441C5.02051 8.07861 4.9834 7.81836 4.62061 7.68994C4.01221 7.4751 3.38867 7.22852 2.94678 6.88184C2.47705 6.51318 2.26074 5.88086 2.3833 5.23193C2.50928 4.56494 2.96094 4.02783 3.57178 3.80908C3.61914 3.45068 3.92529 3.17383 4.29688 3.17383C4.69434 3.17383 5.01709 3.49072 5.02832 3.88525C5.1875 3.94385 5.33984 4.01318 5.48047 4.08643C5.90234 4.30615 6.00049 4.8667 5.67773 5.2168C5.4502 5.46387 5.08154 5.52344 4.79053 5.35645C4.56201 5.2251 4.29199 5.11816 4.08154 5.18164C3.88672 5.24023 3.83398 5.44287 3.82275 5.50342C3.79883 5.62988 3.83301 5.71484 3.85107 5.729C4.12744 5.9458 4.6416 6.14404 5.1084 6.30859C6.06543 6.64697 6.59717 7.53467 6.43213 8.51709Z"
                      fill="white"
                    />
                    <path
                      d="M3.4668 18.3105H5.12695V19.9707H3.4668V18.3105Z"
                      fill="white"
                    />
                    <path
                      d="M16.748 13.623H21.5332V15.2832H16.748V13.623Z"
                      fill="white"
                    />
                    <path
                      d="M22.8027 10.2051H15.5273C14.3159 10.2051 13.3301 11.1909 13.3301 12.4023V22.8027C13.3301 24.0142 14.3159 25 15.5273 25H22.8027C24.0142 25 25 24.0142 25 22.8027V12.4023C25 11.1909 24.0142 10.2051 22.8027 10.2051ZM15.2832 12.8906C15.2832 12.4861 15.6111 12.1582 16.0156 12.1582H22.2656C22.6701 12.1582 22.998 12.4861 22.998 12.8906V16.0156C22.998 16.4201 22.6701 16.748 22.2656 16.748H16.0156C15.6111 16.748 15.2832 16.4201 15.2832 16.0156V12.8906ZM16.0166 22.998C15.6121 22.998 15.2839 22.6701 15.2839 22.2656C15.2839 21.8611 15.6116 21.5332 16.0161 21.5332H16.0166C16.4211 21.5332 16.749 21.8611 16.749 22.2656C16.749 22.6701 16.4211 22.998 16.0166 22.998ZM16.0166 19.873C15.6121 19.873 15.2839 19.5451 15.2839 19.1406C15.2839 18.7361 15.6116 18.4082 16.0161 18.4082H16.0166C16.4211 18.4082 16.749 18.7361 16.749 19.1406C16.749 19.5451 16.4211 19.873 16.0166 19.873ZM19.1416 22.998C18.7371 22.998 18.4089 22.6701 18.4089 22.2656C18.4089 21.8611 18.7366 21.5332 19.1411 21.5332H19.1416C19.5461 21.5332 19.874 21.8611 19.874 22.2656C19.874 22.6701 19.5461 22.998 19.1416 22.998ZM19.1416 19.873C18.7371 19.873 18.4089 19.5451 18.4089 19.1406C18.4089 18.7361 18.7366 18.4082 19.1411 18.4082H19.1416C19.5461 18.4082 19.874 18.7361 19.874 19.1406C19.874 19.5451 19.5461 19.873 19.1416 19.873ZM22.2666 22.998C21.8621 22.998 21.5339 22.6701 21.5339 22.2656C21.5339 21.8611 21.8616 21.5332 22.2661 21.5332H22.2666C22.6711 21.5332 22.999 21.8611 22.999 22.2656C22.999 22.6701 22.6711 22.998 22.2666 22.998ZM22.2666 19.873C21.8621 19.873 21.5339 19.5451 21.5339 19.1406C21.5339 18.7361 21.8616 18.4082 22.2661 18.4082H22.2666C22.6711 18.4082 22.999 18.7361 22.999 19.1406C22.999 19.5451 22.6711 19.873 22.2666 19.873Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_66_2653">
                      <rect width="25" height="25" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              Transaction History
            </NavLink>
          </li>
          <li className="">
            <NavLink
              to="/system-access"
              className={`${styles.link} ${pageActive.includes("/system-access") && styles.active
                } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <path
                    d="M10.2247 16.8073H10.6262C10.8922 16.8073 11.1081 16.5918 11.1081 16.3253V16.0578C11.1081 15.9693 11.1801 15.8973 11.2686 15.8973H12.0431C12.1121 15.8973 12.1731 15.9413 12.1951 16.0068C12.6576 17.4033 13.9751 18.4133 15.5246 18.4133C17.458 18.4133 19.031 16.8403 19.031 14.9068C19.031 12.9734 17.458 11.4004 15.5246 11.4004C13.9756 11.4004 12.6576 12.4104 12.1951 13.8063C12.1731 13.8718 12.1121 13.9163 12.0431 13.9163H6.45074C6.18475 13.9163 5.96875 14.1318 5.96875 14.3983V15.4153C5.96875 15.6813 6.18425 15.8973 6.45074 15.8973H7.11973C7.20823 15.8973 7.28022 15.9693 7.28022 16.0578V16.9413C7.28022 17.2073 7.49572 17.4233 7.76221 17.4233H8.16371C8.4297 17.4233 8.6457 17.2078 8.6457 16.9413V16.0578C8.6457 15.9693 8.7177 15.8973 8.80619 15.8973H9.58218C9.67068 15.8973 9.74267 15.9693 9.74267 16.0578V16.3253C9.74267 16.5913 9.95817 16.8073 10.2247 16.8073ZM15.5246 13.3279C16.3965 13.3279 17.1035 14.0348 17.1035 14.9068C17.1035 15.7788 16.3965 16.4858 15.5246 16.4858C14.6526 16.4858 13.9456 15.7788 13.9456 14.9068C13.9456 14.0348 14.6526 13.3279 15.5246 13.3279Z"
                    fill="white"
                  />
                  <path
                    d="M1.36299 20.9502H23.637C23.8025 20.9502 23.937 20.8157 23.937 20.6502V8.09996C23.937 6.94198 22.9951 6 21.8371 6H18.5536C18.4267 6 18.3132 6.08 18.2707 6.2C18.1357 6.58149 17.8417 6.88048 17.4637 7.01998C17.3847 7.04898 17.3212 7.11048 17.2897 7.18848C17.2792 7.21448 17.2687 7.24048 17.2577 7.26597C17.2247 7.34397 17.2262 7.43197 17.2612 7.50897C17.3427 7.68597 17.3842 7.87596 17.3842 8.07446C17.3842 8.23995 17.5187 8.37395 17.6842 8.37395H21.2626C21.4281 8.37395 21.5626 8.50845 21.5626 8.67395V19.5662C21.5626 19.7317 21.4281 19.8662 21.2626 19.8662H3.73695C3.57145 19.8662 3.43695 19.7317 3.43695 19.5662V8.67395C3.43695 8.50845 3.57145 8.37395 3.73695 8.37395H7.31537C7.48087 8.37395 7.61537 8.23995 7.61537 8.07446C7.61537 7.87646 7.65687 7.68647 7.73837 7.50997C7.77387 7.43347 7.77487 7.34547 7.74187 7.26747C7.73087 7.24148 7.71987 7.21498 7.70937 7.18898C7.67787 7.11048 7.61437 7.04948 7.53537 7.01998C7.15788 6.88048 6.86388 6.58149 6.72889 6.2005C6.68639 6.0805 6.57339 6.0005 6.44589 6.0005H3.16246C2.00448 6.0005 1.0625 6.94248 1.0625 8.10046V20.6507C1.0625 20.8162 1.197 20.9507 1.36249 20.9507L1.36299 20.9502Z"
                    fill="white"
                  />
                  <path
                    d="M7.987 6.50437L8.10949 6.50837C8.20499 6.84236 8.33749 7.16286 8.50549 7.46535L8.42249 7.55435C8.14049 7.85684 8.14849 8.32233 8.44099 8.61483L9.13547 9.30931C9.42797 9.60181 9.89346 9.60981 10.196 9.32781L10.286 9.24382C10.5894 9.41231 10.9094 9.54531 11.2419 9.64031L11.2459 9.7628C11.2599 10.1763 11.5954 10.4998 12.0089 10.4998H12.9914C13.4049 10.4998 13.7399 10.1758 13.7544 9.7628L13.7584 9.64031C14.0924 9.54481 14.4129 9.41231 14.7154 9.24432L14.8044 9.32731C15.1069 9.60931 15.5723 9.60131 15.8648 9.30881L16.5593 8.61433C16.8518 8.32183 16.8598 7.85584 16.5773 7.55385L16.4933 7.46385C16.6618 7.16036 16.7948 6.84036 16.8898 6.50787L17.0123 6.50387C17.4258 6.48937 17.7493 6.15438 17.7493 5.74089V4.75841C17.7493 4.34491 17.4258 4.00992 17.0123 3.99542L16.8898 3.99142C16.7943 3.65743 16.6618 3.33693 16.4938 3.03444L16.5768 2.94544C16.8588 2.64295 16.8508 2.17746 16.5583 1.88496L15.8638 1.19048C15.5713 0.897982 15.1054 0.889982 14.8034 1.17198L14.7134 1.25598C14.4099 1.08748 14.0899 0.954481 13.7574 0.859483L13.7534 0.736985C13.7389 0.323494 13.4039 0 12.9904 0H12.0079C11.5944 0 11.2594 0.323494 11.2449 0.736985L11.2409 0.859483C10.9069 0.954981 10.5864 1.08748 10.284 1.25547L10.195 1.17248C9.89246 0.890482 9.42697 0.898482 9.13447 1.19098L8.43999 1.88546C8.14749 2.17796 8.13949 2.64395 8.42149 2.94594L8.50549 3.03594C8.33699 3.33943 8.20399 3.65943 8.10899 3.99192L7.9865 3.99592C7.573 4.01042 7.24951 4.34541 7.24951 4.7589V5.74139C7.24951 6.15488 7.5735 6.48987 7.9865 6.50437H7.987ZM12.4999 3.23344C13.6119 3.23344 14.5164 4.13792 14.5164 5.2499C14.5164 6.36187 13.6119 7.26636 12.4999 7.26636C11.3879 7.26636 10.4834 6.36187 10.4834 5.2499C10.4834 4.13792 11.3879 3.23344 12.4999 3.23344Z"
                    fill="white"
                  />
                  <path
                    d="M24.0995 21.5503H15.7652C15.5997 21.5503 15.4652 21.6848 15.4652 21.8503C15.4607 22.5543 14.8852 23.1233 14.1752 23.1233H10.8243C10.1143 23.1233 9.53881 22.5543 9.53431 21.8503C9.53431 21.6848 9.39981 21.5503 9.23432 21.5503H0.899982C0.402992 21.5503 0 21.9533 0 22.4503V22.9003C0 24.0602 0.939981 25.0002 2.09996 25.0002H22.8995C24.0595 25.0002 24.9995 24.0602 24.9995 22.9003V22.4503C24.9995 21.9533 24.5965 21.5503 24.0995 21.5503Z"
                    fill="white"
                  />
                </svg>
              </span>
              System Access
            </NavLink>
          </li>
          <li className="">
            <Accordion.Item
              className={`${styles.accordionWrp} border-0 bg-transparent`}
              eventKey="4"
            >
              <Accordion.Header
                className={`${styles.accordionBtn} fw-bold d-flex align-items-center gap-10`}
              >
                <span className={`${styles.icn} ${styles.fill} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 25 25"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_1_4635)">
                      <path
                        d="M24.445 10.3249L21.5773 9.61968C21.405 9.07607 21.1833 8.54893 20.9157 8.04468C21.3463 7.32798 22.2511 5.81953 22.2511 5.81953C22.4242 5.5313 22.3784 5.16221 22.141 4.92476L20.0696 2.85337C19.8321 2.61519 19.4638 2.56943 19.1748 2.74321L16.946 4.07861C16.4446 3.81323 15.9204 3.59365 15.3804 3.42271L14.6751 0.555078C14.5936 0.228906 14.301 0 13.9648 0H11.0352C10.699 0 10.4057 0.228906 10.3249 0.555029C10.3249 0.555029 9.83638 2.55649 9.62036 3.42197C9.04458 3.60435 8.48813 3.84111 7.95811 4.13008L5.64712 2.74321C5.35815 2.57153 4.99053 2.61592 4.75234 2.85337L2.68096 4.92476C2.44351 5.16221 2.39771 5.5313 2.5708 5.81953L3.9999 8.20635C3.76958 8.66055 3.57646 9.1333 3.42271 9.61753L0.555078 10.3249C0.228906 10.4064 0 10.699 0 11.0352V13.9648C0 14.301 0.228906 14.5943 0.555029 14.6751L3.42339 15.3803C3.59722 15.9318 3.82319 16.4675 4.09717 16.9818L2.81831 19.1132C2.64521 19.4015 2.69102 19.7706 2.92847 20.008L4.99985 22.0794C5.23662 22.3162 5.60566 22.3612 5.89463 22.1896C5.89463 22.1896 7.32871 21.3298 8.0311 20.9092C8.53965 21.1803 9.07178 21.4042 9.62041 21.578L10.325 24.4449C10.4057 24.7711 10.699 25 11.0352 25H13.9648C14.301 25 14.5936 24.7711 14.6751 24.445L15.3796 21.578C15.944 21.3992 16.4875 21.1682 17.0047 20.8878C17.7264 21.3205 19.1748 22.1896 19.1748 22.1896C19.463 22.3619 19.8321 22.3176 20.0695 22.0794L22.1409 20.008C22.3784 19.7706 22.4242 19.4015 22.2511 19.1132L20.9343 16.9195C21.1939 16.4267 21.4092 15.911 21.5773 15.3803L24.4449 14.6751C24.7711 14.5936 25 14.301 25 13.9648V11.0352C25 10.699 24.7711 10.4064 24.445 10.3249ZM12.5 17.627C9.67329 17.627 7.37305 15.3267 7.37305 12.5C7.37305 9.67329 9.67329 7.37305 12.5 7.37305C15.3267 7.37305 17.627 9.67329 17.627 12.5C17.627 15.3267 15.3267 17.627 12.5 17.627Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_4635">
                        <rect width="25" height="25" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                Configuration
              </Accordion.Header>
              <Accordion.Body className="py-0">
                <ul className="list-unstyled ps-5 mb-0">
                  <li className="">
                    <NavLink
                      to="/configuration/faq"
                      className={`${styles.subLinks} ${pageActive.includes("/faq") && styles.active
                        } text-white`}
                    >
                      FAQs
                    </NavLink>
                  </li>
                  <li className="">
                    <NavLink
                      to="/configuration/content-pages"
                      className={`${styles.subLinks} ${pageActive.includes("/content-pages") && styles.active
                        } text-white`}
                    >
                      Content Pages
                    </NavLink>
                  </li>
                  <li className="">
                    <NavLink
                      to="/configuration/email-template"
                      className={`${styles.subLinks} ${pageActive.includes("/email-template") && styles.active
                        } text-white`}
                    >
                      Email Template
                    </NavLink>
                  </li>
                  <li className="">
                    <NavLink
                      to="/configuration/sms-template"
                      className={`${styles.subLinks} ${pageActive.includes("/sms-template") && styles.active
                        } text-white`}
                    >
                      SMS Template
                    </NavLink>
                  </li>
                  <li className="">
                    <NavLink
                      to="/configuration/basic-setting"
                      className={`${styles.subLinks} ${pageActive.includes("/sms-template") && styles.active
                        } text-white`}
                    >
                      Basic Setting
                    </NavLink>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </li>
        </ul>
      </Accordion>
    </div>
  );
};

export default Sidebar;
